import { Stack } from "@mui/material";
import SearchBar from "./SearchBar";
import StatusFilter from "./StatusFilter";
import DateFilter from "./DateFilter";
import ExportButton from "./ExportButton";
import Accountants from "./Accountants";

export default function Toolbar({
  countPending,
  countReparacion,
  isLoading,
  countryId,
}) {
  return (
    <Stack
      mt={2}
      gap={2}
      direction="row"
      justifyContent="space-between"
      flexWrap="wrap"
    >
      {/* Filtros */}
      <Stack direction="row" gap={2} alignItems="center" flexWrap="wrap">
        <SearchBar />
        <StatusFilter countryId={countryId} />
        <DateFilter />
        <ExportButton countryId={countryId} />
      </Stack>
      {/* //Contadores */}
      <Stack direction="row" gap={2} alignItems="center">
        <Accountants
          countPending={countPending}
          countReparacion={countReparacion}
        />
      </Stack>
    </Stack>
  );
}
